import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { EditFlashMessageRequest } from '../api/flashmessage/edit/editflashmessagesrequest';
import { EditFlashMessageResponse, EditFlashMessageResponseDtoImpl } from '../api/flashmessage/edit/editflashmessagesresponse';

export class EditFlashMessageAPIProcessorImpl extends APIProcessorImpl<EditFlashMessageRequest, EditFlashMessageResponse>
{
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new EditFlashMessageResponseDtoImpl(APIFeatures.EDIT_FLASH_MESSAGE, "Edit EditFlashMessage Success");
                                
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new EditFlashMessageResponseDtoImpl(APIFeatures.EDIT_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new EditFlashMessageResponseDtoImpl(APIFeatures.EDIT_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new EditFlashMessageResponseDtoImpl(APIFeatures.EDIT_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new EditFlashMessageResponseDtoImpl(APIFeatures.EDIT_FLASH_MESSAGE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/editflashmessagesapiprocessor.tsx